import { j as r } from "../../jsx-runtime.BREq8dyb.js";
import { Stack as n, CircularProgress as i, Typography as p } from "@mui/joy";
import { memo as c } from "react";
const x = {
  lg: "h4",
  md: "body-lg",
  sm: "body-md",
  xs: "body-sm"
}, u = c(({
  color: m = "primary",
  variant: t = "soft",
  labelProps: a,
  label: o,
  sx: l,
  size: s = "xs",
  direction: e = "row",
  thickness: d
}) => /* @__PURE__ */ r.jsxs(
  n,
  {
    alignItems: "center",
    direction: e,
    spacing: e?.includes("column") ? 0.5 : 1,
    sx: l,
    width: "fit-content",
    children: [
      /* @__PURE__ */ r.jsx(i, { color: m, size: s, thickness: d, variant: t }),
      o ? /* @__PURE__ */ r.jsx(p, { level: x[s], ...a, children: o }) : null
    ]
  }
));
u.displayName = "DqLoader";
export {
  u as default
};
//# sourceMappingURL=DqLoader.js.map
